import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfig } from '../../../app.settings';
import { MachineScheduleInterface } from '../../interfaces/machine-schedule.interface';
import { MachineInfoDB } from '../../interfaces/machine-info.interface';
import { AndroidDeviceModel } from '../../models/entities/android-device.type';
import { EditMachineModel } from '../../models/entities/edit-machine-type';

@Injectable()
export class ManageSystemService {

  private endpoint: string;

  constructor(private http: HttpClient, private config: AppConfig) {
    this.endpoint = `${this.config.getConfig('api')}Client/ClientService`;
  }

  getAllMachines(): Observable<MachineInfoDB[]> {
    return this.http.get<MachineInfoDB[]>(`${this.endpoint}/GetData`);
  }

  editLocation(machine: EditMachineModel): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/edit-location`, machine);
  }

  restart(machineAddresses: string[]): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/restart`, machineAddresses
    );
  }

  shutDown(machineAddresses: string[]): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/shut-down`, machineAddresses
    );
  }

  disconnect(machineAddresses: string[]): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/disconnect`, machineAddresses);
  }

  downloadLogs(machineAddresses: string[]): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/download-logs`, machineAddresses);
  }

  // TODO no reference
  // getScheduleInfo(machineAddresses: string[]): Observable<null> {
  //   return this.http.post<null>(`${this.endpoint}/getSchedule`, machineAddresses
  //   );
  // }

  scheduleClient(machineScheduleViewModel: MachineScheduleInterface): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/schedule-clients`, machineScheduleViewModel
    );
  }

  cleanMachine(machineAddresses: string[]): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/clean-screens`, machineAddresses);
  }

  updateClient(machineAddresses: string[], updateUrl: string): Observable<null> {
    const params: HttpParams = new HttpParams().set('source', updateUrl);
    return this.http.post<null>(`${this.endpoint}/update-clients`, machineAddresses, { params });
  }

  getServerVersion(): Observable<string> {
    return this.http.get<string>(`${this.endpoint}/server-version`);
  }

  deleteInactive(machineAddresses: string[]): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/delete-inactive`, machineAddresses);
  }

  importUpdateClientFile(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      formData.append('dataURI', JSON.stringify(reader.result));
    }, false);
    reader.readAsDataURL(file);

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', '*/*');

    const req: HttpRequest<any> = new HttpRequest('POST', `${this.endpoint}/Upload-client`, formData, {
      headers,
      reportProgress: true
    });

    return this.http.request(req);
  }

  rotateScreen(machineAddress: string, rotationMode: number): Observable<void> {
    const params: HttpParams = new HttpParams()
      .set('machineAddress', machineAddress)
      .set('screenRotationMode', rotationMode);

    return this.http.post<null>(`${this.endpoint}/rotate-screen`, null, { params });
  }

  changeAndroidMode(machineAddresses: string[], androidMode: number): Observable<void> {
    const params: HttpParams = new HttpParams().set('androidMode', androidMode);
    return this.http.post<null>(`${this.endpoint}/change-android-mode`, machineAddresses, { params });
  }

  connectDevice(androidDevice: AndroidDeviceModel): Observable<void> {
    return this.http.post<null>(`${this.endpoint}/connect-device`, androidDevice);
  }
}
